import { useState } from "react";
import { IconButton, Box, MenuItem, Typography } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { StyledBadge, MenuBox } from "./styled";
import NotificationHeader from "./NotificationHeader";
import NotificationSection from "./NotificationSection";
import { useNotificationsLogic } from "./useNotificationLogic";
import { useTranslation } from "react-i18next";

const NotificationMenu = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);
    const { t } = useTranslation();

    const {
        sections,
        unreadCount,
        loading,
        hasMore,
        page,
        loadNotifications,
        handleNotificationClick,
    } = useNotificationsLogic(() => setAnchorEl(null));

    return (
        <>
            <IconButton
                onClick={(e) => {
                    setAnchorEl(e.currentTarget);
                    loadNotifications(1);
                }}
                data-cy="notification-menu-button"
            >
                <StyledBadge badgeContent={unreadCount} pulse={unreadCount > 0}>
                    <NotificationsIcon sx={{ color: "white" }} />
                </StyledBadge>
            </IconButton>

            <MenuBox
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
            >
                <NotificationHeader loading={loading} />

                {sections.every((section) => section.data.length === 0) &&
                    !loading && (
                        <Box px={2} pb={1} pt={2}>
                            <Typography
                                sx={{
                                    fontStyle: "italic",
                                    color: "#888",
                                    fontSize: "13px",
                                    fontFamily: "Montserrat",
                                }}
                            >
                                {t("notification.empty.data")}
                            </Typography>
                        </Box>
                    )}

                {sections.map((section, index) => (
                    <NotificationSection
                        key={index}
                        title={section.title}
                        data={section.data}
                        onClick={(notif) => {
                            handleNotificationClick(notif);
                        }}
                    />
                ))}

                {hasMore && !loading && (
                    <Box display="flex" justifyContent="center" py={1}>
                        <MenuItem
                            disabled={loading}
                            onClick={() => loadNotifications(page + 1)}
                            sx={{
                                justifyContent: "center",
                                fontWeight: "bold",
                                fontFamily: "Montserrat",
                                borderRadius: "5px",
                            }}
                        >
                            {t("notification.load.more")}
                        </MenuItem>
                    </Box>
                )}
            </MenuBox>
        </>
    );
};

export default NotificationMenu;
